import React from "react"
import { OrderInfoInterface } from "../types"

interface SampleSelectorProps {
    id: number
    orders: OrderInfoInterface[]
    editable:boolean
    setOrders: React.Dispatch<React.SetStateAction<OrderInfoInterface[]>>
}

export const SampleSelector: React.FC<SampleSelectorProps> = ({ id, orders,editable, setOrders }) => {
    

    const handleClick = (orderId:number, sampleId: number, e: React.MouseEvent) => {
        // console.log("editable", editable)
        if(!editable) {return}
        const order = orders.find((o) => o.id === orderId)
        if (!order) {
            console.error("Order not found")
            return
        }
        //selected samples
        const selected=order.samples
            .map((sample, index) => (sample.selected ? index : -1))
            .filter((index) => index !== -1)

        if (e.shiftKey && selected.length > 0) {
            // Range selection
            const currentIndex = order.samples.findIndex((sample) => sample.id === sampleId)
            if (currentIndex === -1) {
                console.error("Sample not found")
                return
            }
            const lastSelectedIndex = selected[selected.length - 1]
            const start = Math.min(lastSelectedIndex, currentIndex)
            const end = Math.max(lastSelectedIndex, currentIndex)
            const newSelected = Array.from({ length: end - start + 1 }, (_, i) => start + i)
            // console.log("newSelected", newSelected)
            setOrders((prevOrders) => {
                const newOrders = prevOrders.map((order) => {
                    if (order.id === orderId) {
                        const newSamples = order.samples.map((sample, index) => {
                            if (newSelected.includes(index)) {
                                return { ...sample, selected: true }
                            }
                            return { ...sample, selected: false }
                        })
                        return { ...order, samples: newSamples }
                    }
                    return order
                })
                return newOrders
            })
            return
            
        } else if (e.ctrlKey || e.metaKey) {
            // Toggle selection
            const currentIndex = order.samples.findIndex((sample) => sample.id === sampleId)
            if (currentIndex === -1) {
                console.error("Sample not found")
                return
            }
            let newSelected: number[]
            if (selected.includes(currentIndex)) {
                // If already selected, remove it
                newSelected = selected.filter((i) => i !== currentIndex)
            }
            else {
                // If not selected, add it
                newSelected = [...selected, currentIndex]
            }
            setOrders((prevOrders) => {
                const newOrders = prevOrders.map((order) => {
                    if (order.id === orderId) {     
                        const newSamples = order.samples.map((sample, index) => {
                            if (newSelected.includes(index)) {
                                return { ...sample, selected: true }
                            }
                            return { ...sample, selected: false }
                        })
                        return { ...order, samples: newSamples }
                    }
                    return order
                })
                return newOrders
            })
        } else {
            // Single select or add to selection if already selected
            const newSelected = order.samples.map((sample, index) => {
                if (sample.id === sampleId) {
                    return { ...sample, selected: !sample.selected }
                }
                return { ...sample, selected: false }
            })
            setOrders((prevOrders) => {
                const newOrders = prevOrders.map((order) => {
                    if (order.id === orderId) {
                        return { ...order, samples: newSelected }
                    }
                    return order
                })
                return newOrders
            }
            )
            return
        }
        

    }
    if (!orders || orders.length === 0) {
        return <div>No samples available</div>
    }
    // console.log(orders?.[0]?.samples)
    const order = orders.find((order) => order.id === id)
    return (
        <div>
            {order && <div style={{ marginBottom: 8, fontWeight: 600, fontSize: 16 }}>Sample selection for order {order.id}: </div>}
            <div style={{ display: "flex", flexWrap: "wrap", gap: 12 }}>
                {order?.samples.map((sample, idx) => (
                    <div
                        key={idx}
                        onClick={(e) => handleClick(order?.id??0,sample.id??0, e)}
                        style={{
                            minWidth: 60,
                            height: 50,
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            padding: 4,
                            border: sample.selected ? "2px solid #1890ff" : "1px solid #ccc",
                            borderRadius: 6,
                            background: sample.selected? "#e6f7ff" : "#fafafa",
                            cursor: "pointer",
                            fontWeight: 500,
                            fontSize: 11,
                            userSelect: "none",
                            textAlign: "center",
                            // boxShadow: sample.selected ? "0 0 6px #1890ff44" : undefined,
                        }}
                        title={`${sample.sampleName}${sample.samplenum !== null && sample.samplenum !== undefined ? ` (#${sample.samplenum})` : ''}`}
                    >
                        {sample.samplenum !== null && sample.samplenum !== undefined && (
                            <div style={{ fontSize: 10, color: "#888" }}>#{sample.samplenum}</div>
                        )}
                        <div style={{ fontSize: 12, fontWeight: 600 }}>{sample.sampleName}</div>
                    </div>
                ))}
            </div>
        </div>
    )
}
